<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div class="sl-card">

        <!-- title -->
        <div class="sl-card__title">
            {{ $t('card.return_conditions.title') }}
        </div>

        <!-- key/value (separate lines) -->
        <div v-for="prop in return_data" :key="prop.parameterCode" class="sl-card-details__line">
            <div class="sl-card-details__line-label">
                {{ $t(`parameters.${prop.parameterCode}.label`) }}:
            </div>

            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="sl-card-details__line-value" v-html="$pf(prop.parameterValue, prop.parameterCode, 'value')"></div>
        </div>

    </div>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

import ParametersCollection from '@/utils/ParametersCollection.js';

export default
{
    name: 'OrderReturnConditionsCard',

    props:
    {
        order:
        {
            type:     Object,
            required: true,
        },
    },

    computed:
    {
        return_data()
        {
            const protoCode = this.prototypeCode ?? this.prototypeCodeReference;
            const parametersCollection = new ParametersCollection(this.$store, this.order.return_data, protoCode);

            // Order values
            return parametersCollection.getAccessibleItems();
        },

        prototypeCode()
        {
            return this.order.article_data['PROTOTYPE_CODE'];
        },

        prototypeCodeReference()
        {
            return this.order.article_data['PROTOTYPE_CODE_REFERENCE'];
        },
    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>



</style>
